export const LOAD_INVOICE_STATUS = 'LOAD_INVOICE_STATUS'